// extracted by mini-css-extract-plugin
export default {"errorMessage":"NoDoctorsAssignedError_errorMessage__O39V2"};